// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__A06Bc","left":"styles_left__1IDYp"};